import { TEST, TEST_TAB_KEYS } from "../actions/types";

const initialState = {
  tests: [],
  test: null,
  error: null,
  loading: true,
  isSaving: false,
  isSavingTask: false,
  isDeletingTest: false,
  duplicateTestId: null,
  isChangesSaveFailed: false,
  activeTabKey: TEST_TAB_KEYS.CREATE,
};

const testReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TEST.LOADED:
      return { ...state, tests: payload, loading: false, error: null, isChangesSaveFailed: false };
    case TEST.SAVE_STATE:
      return { ...state, test: payload };
    case TEST.CREATED:
    case TEST.UPDATED:
      return { ...state, test: payload, loading: false, isSaving: false, duplicateTestId: null };
    case TEST.SAVING:
      return { ...state, isSaving: payload };
    case TEST.LOADING:
      return { ...state, loading: payload };
    case TEST.TASK_SAVING:
      return { ...state, isSavingTask: payload };
    case TEST.DELETED:
      return {
        ...state,
        loading: false,
        isDeletingTest: false,
        duplicateTestId: null,
        tests: state.tests.filter(({ testId }) => testId !== payload),
      };
    case TEST.UPDATE_TREE:
      return { ...state, test: { ...state.test, tree: payload } };
    case TEST.DUPLICATED:
      return { ...state, tests: [payload, ...state.tests], loading: false, duplicateTestId: payload._id };
    case TEST.UPDATE:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default testReducer;
